<template>
  <v-layout>
    <v-dialog :modelValue="dialog" @click:outside="$emit('close')" @keydown.esc="$emit('close')" max-width="500px" transition="dialog-bottom-transition">
      <v-card>
        <v-form @submit.prevent ref="form" v-model="valid" v-on:submit.prevent="updateItem">
          <v-card-title>
            <span class="headline">Editar Tipo de Cubicaje</span>
          </v-card-title>

          <v-card-text>
            <!-- START FORM DIALOG -->
            <div class="row">
              <div class="col-md-12">
                <p class="mb-2">
                  <strong>LPN:</strong> {{ lpnItem ? lpnItem.code : '' }}
                </p>

                <v-combobox
                  v-model="item.cubication_type"
                  name="cubication_type"
                  item-title="name"
                  item-value="id"
                  :items="cubication_types"
                  label="Tipo de Cubicaje"
                  autocomplete="off"
                  clearable
                ></v-combobox>
              </div>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="$emit('close')">Cerrar</v-btn>
            <v-btn color="success" text type="submit" :loading="loading">Actualizar</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { cubicationTypeService } from "@/libs/ws/cubicationTypeService";
import ValidMixin from "@/mixins/ValidMixin.vue";
export default {
  mixins: [ValidMixin],
  props: {
    service: Object,
    dialog: Boolean,
    lpnItem: Object,
    loadList: Function,
    close: Function,
  },
  data() {
    return {
      loading: false,
      cubication_types: [],
      item: {
        cubication_type: null,
      },
    };
  },
  watch: {
    dialog() {
      if (this.dialog) {
        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }

        if (this.lpnItem != null) {
          this.item.cubication_type = this.lpnItem.cubication_type;
        }
      }
    },
  },
  mounted() {
    this.loadCubicationTypes();
  },
  methods: {
    loadCubicationTypes() {
      cubicationTypeService
        .filter({})
        .then((response) => {
          this.cubication_types = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        });
    },
    updateItem() {
      if (this.loading) return;

      this.loading = true;

      var data = {
        id: this.lpnItem.id,
        cubication_type: this.item.cubication_type,
      };

      this.service
        .update(data)
        .then((response) => {
          if (response.status) {
            this.toast.success("El tipo de Cubicaje se actualizó correctamente");
            this.$emit("close");
            this.$emit("loadList");
          } else {
            if (Object.prototype.hasOwnProperty.call(response, "message")) {
              this.toast.error(response.message);
            } else {
              this.toast.error(response.msg);
            }
          }
        })
        .catch((e) => {
          this.toast.error(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
